// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_ktC","cls2":"WorkCard-cls2_icI WorkCard-cls1_ktC"};